module.exports = __webpack_public_path__ + "static/media/setting.7590c939.svg";